import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import BugsnagPerformance from '@bugsnag/browser-performance';
import Vue from 'vue';
import store from './store';

if (!window.env.BUGSNAG_API_KEY) {
    console.error('BUGSNAG_API_KEY is not set');
} else {
    Bugsnag.start({
        apiKey: window.env.BUGSNAG_API_KEY,
        plugins: [new BugsnagPluginVue()],
        appVersion: '1.0.0',
        releaseStage: process.env.APP_ENV || 'production',
        onError: (event) => {
            event.addMetadata('source', {appType: 'frontend'});
            const user = store.state.auth.user; // Access the authenticated user from the store
            if (user) {
                event.setUser(user.uuid, user.email, user.fullName);
            } else {
                const email = sessionStorage.getItem('onboardingEmail');
                if (email) {
                    event.setUser(null, email, null);
                }
            }
        },
    });
    BugsnagPerformance.start({apiKey: window.env.BUGSNAG_API_KEY});

    const bugsnagVue = Bugsnag.getPlugin('vue');
    bugsnagVue.installVueErrorHandler(Vue);
}
export default Bugsnag;
